"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECURRENCE_RULE_FREQUENCY = void 0;
exports.RECURRENCE_RULE_FREQUENCY = {
    YEARLY: 'YEARLY',
    MONTHLY: 'MONTHLY',
    WEEKLY: 'WEEKLY',
    DAILY: 'DAILY',
};
//# sourceMappingURL=recurrence-rule.types.js.map